import React from 'react';
import { CheckIcon, StarIcon, ZapIcon, RotateCcwIcon } from 'lucide-react';
import { offerIncludes } from '../../data/content';
import { images } from '../../data/images';
import { useCountdown } from '../../hooks/useCountdown';
import { CtaButton } from './CtaButton';
export function OfferCard() {
  const {
    minutes,
    seconds
  } = useCountdown(14 * 60 + 59);
  return <section id="offer" className="scroll-mt-4 bg-cream py-20 sm:py-28" data-id="element-133" data-mp="qdf8p4n31if7">
      <div className="mx-auto max-w-6xl px-6 lg:px-10" data-id="element-134" data-mp="ld9f3ix95luh">
        <div className="grid overflow-hidden rounded-[4px] border border-ink/15 bg-white lg:grid-cols-2" data-id="element-135" data-mp="gkq50vxrx8uf">
          <div className="relative flex items-center bg-sand" data-id="element-136" data-mp="civ4htno2zhp">
            <img src={images.product} alt="No-Work Renovations book, tablet and phone screens, workbook, and bonus guides including the Renovation Planner and Materials Catalogue" className="aspect-[4/3] w-full object-cover" data-id="element-137" data-mp="7kjspddtaewu" />
            <span className="absolute left-5 top-5 bg-danger px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-white" data-id="element-138" data-mp="3tri0o71cxcd5">Today only</span>
          </div>

          <div className="p-8 sm:p-12" data-id="element-139" data-mp="176lwfaug1n39">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-140" data-mp="1bzeyts2fwjc6">Complete access</p>
            <div className="mt-3 flex items-center gap-2 text-sm text-body" data-id="element-141" data-mp="xb23mxb6f4iq">
              <span className="flex text-gold" aria-label="Rated 4.8 out of 5" data-id="element-142" data-mp="1293u43axm648">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden data-id="element-143" data-mp="1q0980cxbaobw" data-mpi={i} />)}
              </span>
              <span data-id="element-144" data-mp="1uvye6z3u73h6"><strong className="text-ink" data-id="element-145" data-mp="1uvybusgd6re0">4.8 / 5.0</strong> (+1,253 downloads)</span>
            </div>
            <h2 className="mt-5 font-serif text-2xl font-bold leading-snug text-ink sm:text-3xl" data-id="element-146" data-mp="1g34lud3gusv3">
              Reforms Without Renovation + 101 Solutions + 8 Free Bonuses
            </h2>

            <div className="mt-6 flex items-end gap-4" data-id="element-147" data-mp="4npqfdqwo923">
              <span className="text-xl text-body line-through decoration-danger/70" data-id="element-148" data-mp="9lr8pwgic4ci">$49.99</span>
              <span className="font-serif text-6xl font-bold leading-none text-ink" data-id="element-149" data-mp="2c7mxd2dhkkg1">$27 <span className="font-sans text-lg font-bold text-body" data-id="element-150" data-mp="278im86704cn2">USD</span></span>
            </div>
            <p className="mt-3 inline-block bg-gold-soft px-3 py-1 text-xs font-bold uppercase tracking-wider text-ink" data-id="element-151" data-mp="22ha8wz2jw74m">
              Save $22.99 — 46% off
            </p>

            <ul className="mt-7 space-y-3" data-id="element-152" data-mp="1xgmlsohg0afo">
              {offerIncludes.map(item => <li key={item} className="flex gap-3 text-[15px] leading-relaxed text-ink" data-id="element-153" data-mp="1sh9pld4olr0f">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden data-id="element-154" data-mp="1ojvibr0k9tb2" />
                  {item}
                </li>)}
            </ul>

            <CtaButton variant="gold" className="mt-8 w-full" data-id="element-155" data-mp="1ekmoqz9lygp8">I want my 101 solutions</CtaButton>
            <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-body" data-id="element-156" data-mp="3dvnws3xb0mkn">
              <li className="flex items-center gap-1.5" data-id="element-157" data-mp="38yxdz8u47cvj"><CheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden data-id="element-158" data-mp="3gh52k5vszapo" />One-time payment</li>
              <li className="flex items-center gap-1.5" data-id="element-159" data-mp="3gfaqlh2iesxq"><ZapIcon className="h-3.5 w-3.5 text-gold" aria-hidden data-id="element-160" data-mp="3lfgc0fi6rj7d" />Instant access</li>
              <li className="flex items-center gap-1.5" data-id="element-161" data-mp="3q6exruly19i0"><RotateCcwIcon className="h-3.5 w-3.5 text-gold" aria-hidden data-id="element-162" data-mp="3q7qaijxd9rl9" />7-Day Guarantee</li>
            </ul>

            <div className="mt-8 border-t border-ink/10 pt-6 text-center" data-id="element-163" data-mp="3v84632hs792e">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-ink" data-id="element-164" data-mp="2xju3ala68ha8">Your reserved price is available for:</p>
              <div className="mt-3 flex items-center justify-center gap-3 font-serif text-ink" role="timer" aria-live="off" data-id="element-165" data-mp="32jgkf5t4ehob">
                <TimeUnit value={minutes} label="min" data-id="element-166" data-mp="3cfa4rbd2zfgn" />
                <span className="text-3xl font-bold text-gold" data-id="element-167" data-mp="3cguwyubxambc">:</span>
                <TimeUnit value={seconds} label="sec" data-id="element-168" data-mp="mp6gpcz1idoc" />
              </div>
              <p className="mt-3 text-sm text-body" data-id="element-169" data-mp="rot4uhgepebx">After that, the regular price goes back to $49.99.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function TimeUnit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex min-w-[76px] flex-col items-center bg-ink px-4 py-2 text-cream" data-id="element-170" data-mp="lb5fzo6gsta2">
      <span className="text-3xl font-bold tabular-nums" data-id="element-171" data-mp="za4z6gb7kfyu">{value}</span>
      <span className="font-sans text-[10px] font-bold uppercase tracking-widest text-gold-soft" data-id="element-172" data-mp="u8pjz4vpp3od">{label}</span>
    </div>;
}